// =============================================================================
// Partner Web App — Auth + shell
// =============================================================================

import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { getSupabaseClient, useAuthStore } from "@veorest/api-client";
import { I18nProvider, useI18n } from "./i18n";
import { ProtectedRoute } from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import DashboardPage from "./pages/DashboardPage";
import { ROUTES } from "./routes";

function AppRoutes() {
  const { direction } = useI18n();
  const { setUser, setSession, setLoading } = useAuthStore();

  useEffect(() => {
    const supabase = getSupabaseClient();

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, [setUser, setSession, setLoading]);

  return (
    <BrowserRouter>
      <Toaster
        position={direction === "rtl" ? "top-left" : "top-right"}
        toastOptions={{
          style: {
            borderRadius: "var(--radius-md)",
            background: "var(--surface-raised)",
            color: "var(--text-primary)",
            boxShadow: "var(--shadow-popover)",
          },
        }}
      />
      <Routes>
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.CHANGE_PASSWORD} element={<ChangePasswordPage />} />
        <Route path={ROUTES.APP_ROOT} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route
          path="/app/*"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AppRoutes />
    </I18nProvider>
  );
}
